<template>
  <div class="product-info-component">
    <div class="header">
      <template v-if="product.productType === 'course'">所属课程</template>
      <template v-else-if="product.productType === 'project'">所属项目</template>
      <template v-else>所属产品</template>
    </div>
    <div class="product-info"
         @click="handleProductDetail(product.productType, product.id)"
    >
      <cover class="cover"
             :cover="product.cover"
             :alt="product.title"
      />
      <div class="item-info">
        <h3 class="item-title ym-two-line-ellipsis">{{ product.title }}</h3>
        <div class="item-bottom">
          <div class="item-bottom-left">
            <p class="item-summary ym-line-ellipsis">{{ product.summary }}</p>
            <p class="item-desc" v-if="product.desc && product.desc !== ''">
              {{ product.desc }}
            </p>
          </div>
          <status :render="product.render"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Status from '@/components/ProductStatus';
  import Cover from '@/components/ProductCover';

  export default {
    name: 'WorkCourseInfoComponent',
    components: {
      Status,
      Cover,
    },
    props: {
      product: {
        type: Object,
        required: true,
      },
    },
    methods: {
      handleProductDetail(type, id) {
        if (type === 'course') {
          const route = { name: 'CourseDetail', params: { id } };
          this.$router.push(route);
          return;
        }
        const route = { name: 'ProjectDetail', params: { id } };
        this.$router.push(route);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .product-info-component {
    margin-bottom: @size-small;
    background: @color-white;
  }

  .header {
    padding: @size-base;
    font-size: @font-size-medium;
    font-weight: @font-weight-primary;
    color: @color-text-base;
    line-height: 1;
    border-bottom: @border-base;
  }

  .product-info {
    overflow: hidden;
    display: flex;
    padding: @size-base;
    box-sizing: border-box;
  }

  .cover {
    margin-right: @size-base;
  }

  .item-info {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .item-title {
    margin: 0;
    font-size: @font-size-medium;
    line-height: 1.4;
  }

  .item-bottom {
    overflow: hidden;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }

  .item-bottom-left {
    flex: 1;
    overflow: hidden;
  }

  .item-summary {
    width: 100%;
    margin: 0;
    color: @color-text-light;
    font-size: @font-size-small;
  }

  .item-desc {
    white-space: nowrap;
    margin: @size-extra-small 0 0;
    color: @color-text-lighter;
    font-size: @font-size-extra-small;
  }

</style>
